<ng-container [ngSwitch]="version">
  <app-new-hsc-modal-v1
    *ngSwitchCase="1"
    [settingVisible]="settingVisible"
    [fileTypeList]="fileTypeList"
    (fileList)="fileList.emit($event)"
    (modalStatus)="modalStatus.emit($event)"
  ></app-new-hsc-modal-v1>
  <app-new-hsc-modal-v2
    *ngSwitchCase="2"
    [settingVisible]="settingVisible"
    [fileTypeList]="fileTypeList"
    (fileList)="fileList.emit($event)"
    (modalStatus)="modalStatus.emit($event)"
  ></app-new-hsc-modal-v2>
</ng-container>
